import { useMemo } from 'react';
import { LoanFormConfigDTO } from "@/shared/api/model";
import { useProductPropertiesById } from '@/modules/loan-product-settings/hooks/useProductProperties';

/**
 * Custom hook for parsing loan application form JSON configuration from product data
 * No API call needed - reads directly from product.loanFormConfig
 */
export const useLoanFormTemplate = (product?: any) => {
  const { data: productPropertiesResponse } = useProductPropertiesById(product?.glNo ?? undefined);

  const productProperties = productPropertiesResponse?.data as any;

  const formConfig = useMemo(() => {
    const configJson = productProperties?.loanFormConfig || product?.loanFormConfig;

    if (!configJson) {
      return undefined;
    }

    try {
      const parsed = JSON.parse(configJson) as LoanFormConfigDTO;

      if (parsed && !parsed.branding) {
        parsed.branding = {};
      }

      if (parsed?.branding) {
        parsed.branding.logoUrl =
          productProperties?.loanFormLogoUrl ||
          product?.loanFormLogoUrl ||
          parsed.branding.logoUrl;
        parsed.branding.watermarkUrl =
          productProperties?.loanFormWatermarkUrl ||
          product?.loanFormWatermarkUrl ||
          parsed.branding.watermarkUrl;
      }

      return parsed;
    } catch (error) {
      console.error('Failed to parse loan form config:', error);
      return undefined;
    }
  }, [
    product?.loanFormConfig,
    product?.loanFormLogoUrl,
    product?.loanFormWatermarkUrl,
    productProperties?.loanFormConfig,
    productProperties?.loanFormLogoUrl,
    productProperties?.loanFormWatermarkUrl,
  ]);

  return {
    formConfig,
    hasConfig: !!formConfig,
    language: formConfig?.language || 'EN',
  };
};

export default useLoanFormTemplate;
